import Transformer from './Transformer';

class itemTransformerLevelV3 extends Transformer {
    transform(model) {        
        return {
            id: model.id,
            number: model.number,
            name: model.name,
            hd: model.hd,
            image: model.image,
            group_id: model.group_id,
            subtitle: model.event.name,
            startTime: model.event.date_begin,
            endTime: model.event.date_end,
            type: 'UserLiveChannel',
            event: model.event
        }
    }
}

export default new itemTransformerLevelV3();



// WEBPACK FOOTER //
// ./src/requests/tasks/transformers/itemTransformerLevelV3.js